/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class ProgressRange {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		public constructor() {
			this.current = 0;
			this.currentRatio = 0;

			this.from = 0;
			this.to = 0;

			this.elapsed = 0;
			this.duration = 0;

			this.isStarted = false;
			this.isFinished = false;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public setRange(from:number, to:number):void {
			this.from = from;
			this.to = to;

			this.elapsed = 0;
			this.duration = this.to - this.from;

			this.current = this.from;

			this.isStarted = false;
			this.isFinished = false;

			trace('[ProgressRange] setRange : from     =', this.from);
			trace('[ProgressRange] setRange : to       =', this.to);
			trace('[ProgressRange] setRange : duration =', this.duration);
		}

		public reset():void {
			this.seekByElapsedValue(0);
		}

		public seekByElapsedValue(value:number) {
			if (value > this.duration) value = this.duration;

			this.current = this.from + value;
			if (this.current > this.to) this.current = this.to;

			this.elapsed = this.current - this.from;

			this.currentRatio = value / this.duration;

			this.isStarted = value > 0;
			this.isFinished = value == this.duration;
		}

		public seekByValue(value:number) {
			this.seekByElapsedValue(value - this.from);
		}

		public seekByRatio(ratio:number) {
			this.seekByElapsedValue(this.duration * ratio);
		}

		public progressByValue(value:number) {
			this.seekByValue(this.current + value);
		}

		public progressByRatio(ratio:number) {
			this.seekByRatio(this.currentRatio + ratio);
		}

		public getCurrent():number {
			return this.current;
		}

		public getCurrentRatio():number {
			return this.currentRatio;
		}

		public getElapsed():number {
			return this.elapsed;
		}

		public getDuration():number {
			return this.duration;
		}

		public getIsStarted():boolean {
			return this.isStarted;
		}

		public getIsFinished():boolean {
			return this.isFinished;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private current:number;
		private currentRatio:number;

		private from:number;
		private to:number;

		private elapsed:number;
		private duration:number;

		private isStarted:boolean;
		private isFinished:boolean;
	}
}
